module.exports = __webpack_public_path__ + "static/media/monthly-calendar.011e4faa.svg";